import { useEffect, useRef } from 'react';

import {
  AudioSource,
  PLAYBACK_STATUS_UPDATE,
  createAudioPlayer,
  setAudioModeAsync,
} from 'expo-audio';

import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

setAudioModeAsync({
  playsInSilentMode: true,
  interruptionMode: 'mixWithOthers',
  interruptionModeAndroid: 'duckOthers',
});

/** will play audio once if its defined and allowed */
export const maybePlayAudioOnce = (source: AudioSource | string | number | null = null) => {
  if (region === Region.CA) {
    return; // audio is disabled for CA for now
  }

  if (!source) {
    return;
  }

  const player = createAudioPlayer(source);
  const subscription = player.addListener(PLAYBACK_STATUS_UPDATE, status => {
    if (status.didJustFinish) {
      player.release();
      subscription.remove();
    }
  });
  player.play();
};

/** play audio once on mount if it is defined */
export const useMaybePlayAudioOnceOnMount = (
  source: AudioSource | string | number | null = null,
  shouldPlay = true
) => {
  const didPlayRef = useRef(false);

  useEffect(() => {
    if (source && !didPlayRef.current && shouldPlay) {
      maybePlayAudioOnce(source);
      didPlayRef.current = true;
    }
  }, [source, shouldPlay]);
};
